import { isSmartObject } from '../objects/guards';
import Tool, {
  type IToolActionInput,
  type IToolAvailableInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';

// Convert a smart object into simple objects that can then be edited individually.
class ToolEditSmartObject extends Tool {
  static toolName = 'Edit smart shape';

  static action({ controller }: IToolActionInput) {
    // this will detect the selection and automatically open the editor for this object
    controller.actionOpenSidePanel('smartObject');
  }

  static enabled({ selection }: IToolEnabledInput) {
    return !!(selection && isSmartObject(selection));
  }

  static available({ controller, selection }: IToolAvailableInput) {
    return this.enabled({ controller, selection });
  }

  static buttonComponent() {
    return simpleToolButton(ToolEditSmartObject, 'fa-regular fa-pen-to-square');
  }
}

export default ToolEditSmartObject;
